import { render, staticRenderFns } from "./ProviderManage.vue?vue&type=template&id=6c000caa&scoped=true&"
import script from "./ProviderManage.vue?vue&type=script&lang=js&"
export * from "./ProviderManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c000caa",
  null
  
)

export default component.exports